import React from 'react';
import { useNavigate } from 'react-router-dom';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const WalletBalanceCard = ({ balance, pendingRewards, recentEarnings, payoutSummary }) => {
  const navigate = useNavigate();

  const pendingCount = payoutSummary?.pendingCount || 0;
  const processingCount = payoutSummary?.processingCount || 0;
  const hasActivePayouts = pendingCount > 0 || processingCount > 0;

  return (
    <div className="bg-gradient-to-br from-teal-500 to-blue-600 rounded-xl p-6 md:p-8 text-white shadow-lg">
      <div className="flex items-start justify-between mb-6">
        <div>
          <h2 className="text-lg md:text-xl font-semibold mb-1">Cashback Wallet</h2>
          <p className="text-sm opacity-90">Available balance</p>
        </div>
        <div className="flex items-center gap-2">
          {hasActivePayouts && (
            <div className="flex items-center gap-1.5 bg-white/20 backdrop-blur-sm rounded-full px-2.5 py-1">
              <span className="w-1.5 h-1.5 rounded-full bg-amber-300 animate-pulse" />
              <span className="text-xs font-medium">
                {pendingCount + processingCount} active
              </span>
            </div>
          )}
          <div className="w-12 h-12 md:w-14 md:h-14 rounded-xl bg-white/20 backdrop-blur-sm flex items-center justify-center">
            <Icon name="Wallet" size={24} color="#FFFFFF" />
          </div>
        </div>
      </div>
      <div className="mb-6">
        <div className="flex items-baseline gap-2 mb-4">
          <span className="text-4xl md:text-5xl font-bold">${balance?.toFixed(2)}</span>
          {payoutSummary?.stripeAvailable > 0 && (
            <span className="text-sm opacity-75 flex items-center gap-1">
              <Icon name="Zap" size={12} color="#FFFFFF" />
              Stripe synced
            </span>
          )}
        </div>
        
        <div className="grid grid-cols-2 gap-4">
          <div className="bg-white/10 backdrop-blur-sm rounded-lg p-3 md:p-4">
            <div className="flex items-center gap-2 mb-1">
              <Icon name="Clock" size={16} color="#FFFFFF" />
              <span className="text-xs opacity-90">Pending</span>
            </div>
            <p className="text-lg md:text-xl font-semibold">${pendingRewards?.toFixed(2)}</p>
            {pendingCount > 0 && (
              <p className="text-xs opacity-75 mt-0.5">{pendingCount} payout{pendingCount !== 1 ? 's' : ''}</p>
            )}
          </div>
          
          <div className="bg-white/10 backdrop-blur-sm rounded-lg p-3 md:p-4">
            <div className="flex items-center gap-2 mb-1">
              <Icon name="TrendingUp" size={16} color="#FFFFFF" />
              <span className="text-xs opacity-90">This Month</span>
            </div>
            <p className="text-lg md:text-xl font-semibold">${recentEarnings?.toFixed(2)}</p>
            {processingCount > 0 && (
              <p className="text-xs opacity-75 mt-0.5">{processingCount} processing</p>
            )}
          </div>
        </div>
      </div>
      <div className="flex flex-col sm:flex-row gap-3">
        <Button
          variant="secondary"
          onClick={() => navigate('/transaction-submission-screen')}
          iconName="Upload"
          iconPosition="left"
          fullWidth
          className="bg-white text-teal-600 hover:bg-white/90"
        >
          Submit Purchase
        </Button>
        <Button
          variant="outline"
          onClick={() => navigate('/user-dashboard')}
          iconName="History"
          iconPosition="left"
          fullWidth
          className="border-white/30 text-white hover:bg-white/10"
        >
          View History
        </Button>
      </div>
    </div>
  );
};

export default WalletBalanceCard;